export default "__VITE_ASSET__BZQOqsov__"